import React from "react";
import CircularProgressbar from "react-circular-progressbar";
import moment from "moment";

import "react-circular-progressbar/dist/styles.css";
import "./job-card.scss";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";

export default function JobCard({id, disabled, ...props}) {
    const [t] = useTranslation();
    /** Renders the job card content with a wrapper link or without depending on if the card is disabled */
    function renderLinkOrRaw() {
        return (
            disabled ? renderJobCardContent() :
                <Link to={`/jobs/job-details/${id}`} style={{maxWidth: "100%"}}>
                    {renderJobCardContent()}
                </Link>
        );
    }

    function renderJobCardContent() {
        return (
            <div className={`job-card ${disabled ? "disabled" : ""}`}>
                <div className="job-card-image">
                    <img src={props.plasticType.imagePath} alt="product"/>
                </div>
                <div className="job-card-content">
                    <h5>#{id} {t(props.plasticType.name)}</h5>
                    <span>{t("$")}{props.pricePerKg.toFixed(2)}/kg</span>
                    <img src="/icon-clock.svg" alt=""/>
                    <span>{moment(props.dueByLocal).format("DD MMM YYYY")}</span>
                    <img src="/icon-location.svg" alt=""/>
                    <span>{props.assignedSites[0].name}</span>
                    {props.userCommitment.latestUserCommitment && (
                        <div className="job-card-progress">
                            <CircularProgressbar
                                strokeWidth={14}
                                percentage={
                                    ((props.userCommitment.totalAmountCollected + 0.01) /
                                        props.userCommitment.totalAmountCommitted) *
                                    100
                                }
                            />
                            <span>
                {props.userCommitment.totalAmountCollected}kg/{props.userCommitment.totalAmountCommitted}kg {t("toCollect")}
              </span>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    return renderLinkOrRaw();
}
